// https://github.com/valor-software/ng2-file-upload/blob/development/src/file-upload/file-drop.directive.ts#L25...L38
import { Directive, Output, EventEmitter, HostListener, Input, ElementRef, Renderer2 } from '@angular/core';
@Directive({
    selector: '[fiFileDrop]',
    exportAs: 'fiFileDrop',
    standalone: false,
})
export class FileDropDirective {
    @Output('fiFileDrop') onFileDrop = new EventEmitter<any>();
    @Output() public fileOver: EventEmitter<any> = new EventEmitter();
    @Input() dragoverClass: string = 'fi-file-drop-dragover';
    public dragover: boolean = false;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {
        this.fileOver.subscribe((state: boolean) => {
            if (state) {
                this.renderer.addClass(this.elementRef.nativeElement, this.dragoverClass);
            } else {
                this.renderer.removeClass(this.elementRef.nativeElement, this.dragoverClass);
            }

            this.dragover = state;
        });
    }

    @HostListener('drop', ['$event'])
    public onDrop(event: any): void {
        let transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }

        this._preventAndStop(event);
        this.fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    }

    @HostListener('dragover', ['$event'])
    public onDragOver(event: any): void {
        let transfer = this._getTransfer(event);
        if (!this._haveFiles(transfer.types)) {
            return;
        }

        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        this.fileOver.emit(true);
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave(event: any): any {
        if ((this as any).element) {
            if (event.currentTarget === (this as any).element[0]) {
                return;
            }
        }

        this._preventAndStop(event);
        this.fileOver.emit(false);
    }

    protected _getTransfer(event: any): any {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    }

    protected _preventAndStop(event: any): any {
        event.preventDefault();
        event.stopPropagation();
    }

    protected _haveFiles(types: any): any {
        if (!types) {
            return false;
        }

        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        } else if (types.contains) {
            return types.contains('Files');
        } else {
            return false;
        }
    }
}
